import { useSetPlayerStoreData } from '../hooks'
import { playerStoreKeys } from '../playerStoreConstants'
import { useCallback } from 'react'
import { usePlayerStore } from '../hooks/usePlayerStore'

export const useRemoveNoticeById = () => {
  const { setPlayerStoreData } = useSetPlayerStoreData()
  const playerStore = usePlayerStore()
  const notices = playerStore.use.notices()

  const removeNoticeById = useCallback(
    noticeId => {
      const notUndefined = anyValue => typeof anyValue !== 'undefined'

      let newNotices = notices

      if (noticeId) {
        newNotices = notices
          .map(notice => {
            if (notice.id) {
              if (notice.id !== noticeId) {
                return notice
              }
            } else {
              return notice
            }
          })
          .filter(notUndefined)
      }

      setPlayerStoreData(
        {
          [playerStoreKeys.notices]: newNotices
        },
        'removeNoticeById'
      )
    },
    [notices, setPlayerStoreData]
  )

  return { removeNoticeById }
}
